import { createContext, useContext } from "react";
import type { GameSession } from "./session";

export const SessionContext = createContext<GameSession | null>(null);

export function useSession(): GameSession {
  const session = useContext(SessionContext);
  if (!session) throw new Error("useSession must be used inside a room");
  return session;
}
